// extracted by mini-css-extract-plugin
module.exports = {"card":"SignUpSuccess_card__1GXV7"};